<template>
  <div :id="$attrs['id']" :class="[$attrs['class'], { 'hm-table__th--asc': $parent.$parent.sort === field && $parent.$parent.sortDirection === 'asc' }, { 'hm-table__th--asc': $parent.$parent.sort === field && $parent.$parent.sortDirection === 'desc' }]" class="hm-table__th hm-table__th--sortable" @click="$parent.$parent.$emit('sort', field, number)">
    <slot />
    <i v-if="$parent.$parent.sort === field && $parent.$parent.sortDirection === 'asc'" class="fad fa-sort-up"></i>
    <i v-else-if="$parent.$parent.sort === field && $parent.$parent.sortDirection === 'desc'" class="fad fa-sort-down"></i>
    <i v-else class="fad fa-sort"></i>
  </div>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { split, endsWith, head, isNil, isEmpty, slice, isString } from 'lodash';
import uuid from 'uuid';

export default {
  name: 'SortableTh',

  mixins: [HotelmeisterMixin],

  props: {
    field: {
      required: true,
      type: String,
      default: null,
    },
    number: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "~styles/import";
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/SortableTh.vue